export const CREATE_SALES_BILL = 'CREATE_SALES_BILL';
export const GET_SALES_BILLS = 'GET_SALES_BILLS';
export const GET_SALES_BILLS_PAGE = 'GET_SALES_BILLS_PAGE';
export const SALES_BILL_REQUEST = 'SALES_BILL_REQUEST';
export const UPDATE_SALES_BILL = 'UPDATE_SALES_BILL';
export const DELETE_SALES_BILL = 'DELETE_SALES_BILL';
export const SALES_BILL_REQUEST_FAILURE = 'SALES_BILL_REQUEST_FAILURE';
export const SALES_BILL_REQUEST_SUCCESS = 'SALES_BILL_REQUEST_SUCCESS';
export const GET_AVAILABLE_PURCHASE_BILLS = 'GET_AVAILABLE_PURCHASE_BILLS';
export const CANCEL_EWAY_BILL = 'CANCEL_EWAY_BILL';
